import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ValidationEngineService {

  /**
   * Public method to run all rules against the form data.
   * @param context The form data (header + lines)
   * @param rules The rules array from the API
   */
  public validate(context: any, rules: any[]): any[] {
    const results: any[] = [];

    if (!rules || !Array.isArray(rules)) return results;

    rules.forEach(rule => {
      try {
        // 1. Get the JSON logic (handles both ruleJson and RuleJson casing)
        const jsonStr = rule.ruleJson || rule.RuleJson;
        const config = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr;

        const assert = config?.assert;
        if (!assert) return;

        let isValid = true;
        const operator = assert.operator;
        const targetValue = assert.value;

        // 2. Collection Rules (e.g., "Must have at least one line")
        // Checks inside 'assert' or 'config' for the collection name
        const collectionKey = assert.collection || config.collection;
        if (assert.type === 'collectionCount' || collectionKey) {
          const collection = context[collectionKey] || [];
          isValid = this.evaluate(collection.length, operator, targetValue);
        }

        // 3. Field Rules (e.g., "Grand Total must be 1,000 or greater")
        // Checks inside 'assert' or 'config' for the target field name
        else {
          const targetKey = assert.target || config.target;
          if (targetKey) {
            const actualValue = context[targetKey];
            isValid = this.evaluate(actualValue, operator, targetValue);
          }
        }

        // 4. Create Error Result if validation failed
        if (!isValid) {
          results.push({
            severity: rule.severity || rule.Severity || 'ERROR',
            message: rule.message || rule.Message // Uses the text from your API
          });
        }
      } catch (e) {
        console.error('Validation Engine Error:', e);
      }
    });

    return results;
  }

  /**
   * Helper to compare values (handles numbers and nulls safely)
   */
  private evaluate(actual: any, operator: string, target: any): boolean {
    // Convert to numbers; treat null/undefined as 0
    const a = (actual === null || actual === undefined) ? 0 : Number(actual);
    const t = Number(target);

    switch (operator) {
      case '>=': return a >= t;
      case '<=': return a <= t;
      case '==': return a == t;
      case '!=': return a != t;
      case '>': return a > t;
      case '<': return a < t;
      default: return true;
    }
  }
}